import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./about.scss";
import { PastModal } from "./modals/PastModal";
import { PresentModal } from "./modals/PresentModal";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function About() {
  const [showModalPast, setShowModalPast] = useState(false);
  const [showModalPresent, setShowModalPresent] = useState(false);
  let aboutA = useRef(null);

  useEffect(() => {
    gsap.from(aboutA.current, {
      css: { opacity: 0, width: 0, WebkitFilter: "blur(50px)" },
      duration: 1.5,
      scrollTrigger: {
        trigger: aboutA.current,
        start: "-=200px 50%",
        end: "+=500",
        scrub: false,
        markers: false,
        toggleActions: "play none none reverse",
      },
    });
  }, []);

  const openModalPast = () => {
    setShowModalPast((prev) => !prev);
  };
  const openModalPresent = () => {
    setShowModalPresent((prev) => !prev);
  };

  const { t } = useTranslation();

  return (
    <div className="about" id="about" ref={aboutA}>
      <PastModal
        showModalPast={showModalPast}
        setShowModalPast={setShowModalPast}
      />
      <PresentModal
        showModalPresent={showModalPresent}
        setShowModalPresent={setShowModalPresent}
      />

      <div className="leftContainer"></div>
      <div className="rightContainer">
        <div className="topDescription">
          <div className="topDescriptionBox">
            <h4>{t("Born")}</h4>
          </div>
          <div className="midDescriptionBox">
            <div>
              <p>{t("Coding")}</p>
              <p>{t("loving")}</p>
            </div>
          </div>
          <div className="botDescriptionBox">
            <p>
              {t("Here you can read about my")} <br />
              <span className="pastLink" onClick={openModalPast}>
                {t("PAST")}
              </span>{" "}
              {t("and")}{" "}
              <span className="presentLink" onClick={openModalPresent}>
                {t("PRESENT")}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
